<template>
  <div>
    <label class="d-block">
      {{ $t(config.label) }}
    </label>
    <validation-provider
      :name="$t(`commands.data_types.${config.field_name}`)"
      :rules="config.rules"
      v-slot="{ errors }"
    >
      <v-select
        :options="templates"
        v-model="model"
        :loading="loading"
        :clearable="false"
        :reduce="(val) => val.value"
        :multiple="multiple || multiple === 1"
        :calculate-position="calculatePosition"
        :append-to-body="appendToBody"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        @input="$emit('input', model)"
      />
      <p v-if="config.hint" class="mb-0 small">{{ $t(config.hint) }}</p>
      <p v-if="errors" class="small text-danger">{{ errors[0] }}</p>
    </validation-provider>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { ValidationProvider } from "vee-validate";
import { fetchOperationalFormTemplateOptions } from "@/composables/useOperationalFormTemplateOptions";

export default {
  components: {
    vSelect,
    ValidationProvider,
  },
  props: {
    value: [Array, Object, Number, String],
    multiple: Boolean | Number,
    config: Object,
    context: Object,
    calculatePosition: Function,
    appendToBody: Boolean,
  },
  data() {
    return {
      model: null,
      templates: [],
      loading: false,
    };
  },
  created() {
    this.model = this.value;
  },
  watch: {
    value(next) {
      this.model = next;
    },
  },
  async mounted() {
    this.loading = true;
    try {
      this.templates = await fetchOperationalFormTemplateOptions();
    } finally {
      this.loading = false;
    }
  },
};
</script>
